<template>
    <div
        class="announcement-wrap"
        v-if="announcementMessage != ''"
    >
        <div class="announcement-container">
            <div
                v-show="displayBar && announcementMessage != ''"
                class="bo-announcement-bar"
                :class="[variant, { 'slide-up': slideUp, 'slide-down': slideDown }]"
            >
                <div class="left-panel">
                    <i
                        class="icon-warning"
                        v-if="variant == 'master' || variant == 'warning'"
                    ></i>
                    <i
                        class="icon-info"
                        v-else-if="variant == 'info'"
                    ></i>
                    <i
                        class="icon-filledcheckcircle"
                        v-else-if="variant == 'success'"
                    ></i>
                    <i
                        class="icon-cancelcircle-1"
                        v-else-if="variant == 'danger'"
                    ></i>
                    <span class="announcement">
                        {{ announcementMessage }}
                    </span>
                </div>
                <div class="right-panel">
                    <slot name="announcement_buttons"></slot>
                    <i
                        class="icon-close"
                        @click="closeAnnouncementBar"
                    ></i>
                </div>
            </div>
            <div
                class="announcement-expand"
                v-show="!displayBar"
                @click="openAnnouncementBar"
            >
                <i class="icon icon-chevronright"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        variant: {
            type: String,
            default: "master",
        },
        url: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            announcementMessage: "",
            displayBar: false,
            slideUp: false,
            slideDown: false,
            currentDomain: "",
            currentSite: "",
        };
    },

    mounted() {
        if ("" == this.url) {
        } else {
            axios
                .get(this.url)
                .then((response) => {
                    this.announcementMessage = response.data;
                    if (localStorage.getItem("announcementBarStatus")) {
                        this.display = localStorage.getItem("announcementBarStatus");
                    } else {
                        this.displayBar = false;
                    }
                    // setTimeout(() => {
                    //     this.closeAnnouncementBar();
                    // }, 5000);
                })
                .catch((error) => {});
        }
    },

    watch: {
        displayBar(newVal, oldVal) {
            if (!window.EventBus) {
                window.EventBus = new Vue();
            }
            window.EventBus.$emit("displayBarEnable", this.displayBar);
        },
    },

    methods: {
        toggleAnnouncementBar() {
            this.displayBar = !this.displayBar;
        },
        closeAnnouncementBar() {
            this.slideUp = true;
            this.slideDown = false;
            this.displayBar = false;
            localStorage.setItem("announcementBarStatus", false);
        },
        openAnnouncementBar() {
            this.displayBar = true;
            setTimeout(() => {
                this.slideDown = true;
                this.slideUp = false;
            }, 500);
            localStorage.removeItem("announcementBarStatus");
        },
    },
};
</script>
